export default {
  currentRoute: function currentRoute(state) {
    return state.currentRoute;
  },
  previousRoute: function previousRoute(state) {
    return state.previousRoute;
  },
  currentPage: function currentPage(state) {
    var _state$currentRoute, _state$currentRoute$q;
    var currentPage = (_state$currentRoute = state.currentRoute) === null || _state$currentRoute === void 0 ? void 0 : (_state$currentRoute$q = _state$currentRoute.query) === null || _state$currentRoute$q === void 0 ? void 0 : _state$currentRoute$q.page;
    return currentPage ? +currentPage : 1;
  },
  previousPage: function previousPage(state) {
    var _state$previousRoute, _state$previousRoute$;
    var previousPage = (_state$previousRoute = state.previousRoute) === null || _state$previousRoute === void 0 ? void 0 : (_state$previousRoute$ = _state$previousRoute.query) === null || _state$previousRoute$ === void 0 ? void 0 : _state$previousRoute$.page;
    return previousPage ? +previousPage : null;
  }
};